import EmpoweredCommunity from "../images/empowered-community.jpg"
import Evaluation from "../components/Evaluation"
import Greatness from "../components/Greatness"
import JoinCommunity from "../components/JoinCommunityRow"
import Layout from "../components/layout"
import Quote from "../components/Quote"
import React from "react"
import Helmet  from "react-helmet"
import SEO from "../components/seo"
import cents from "../images/less-than-cents-graphic.svg"
import meetShawna from "../images/meet-shawna.jpg"
import styles from "../styles/about.module.scss"

//Static About Page
const AboutPage = ({ data }) => (
  <Layout>
       <Helmet>
       <title>About | em•power with Shawna | Meet Shawna</title>
       <meta name="title" content="About" />
            <meta name="description" content="I’m Shawna Korgan and I’m here to help you change the world. When we focus within, the results make a difference. Learn more about my online health and wellness program!" />   
             </Helmet>

    <section className={styles.intro}>
      <div className={styles.intro_video}>
        <iframe src="https://player.vimeo.com/video/453481431?color=9fe5e3&title=0&byline=0&portrait=0"  frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
      </div>
      <div className={styles.intro_txt}>
        <p>
          My name is Shawna Korgan and I’m here to help you change the world.
          That may sound like an impossible task but when we are em•powered to
          live our happiest and most productive lives, we make the world a
          better place.
        </p>
        <p>
          My goal, my passion, my purpose is to help you remember your greatness, and 
          to empower you stand in your individual ethos manifest to live healthier 
          by using tools to help you power up and power down.
        </p>
        <p>
          Join me in finding that light within and together we can make a
          difference.
        </p>
      </div>
    </section>

    <section className={styles.ethosManifest}>
      <div className={styles.ethosManifest_cards}>
        <h2 className={styles.orange}>SHAWNA’S ETHOS MANIFEST •EM•</h2>
        <p>These 5 values combined together create the foundation and power behind my Ethos Manifest.</p>
        <div className={styles.cards}>
          <div className={styles.card}>
            <h2 className={styles.card_title}>Love:</h2>
            <p className={styles.card_definition}>
              devotion, admiration, and affection
            </p>
            <p className={styles.card_sentence}>
              "A positive force that is felt deep in the soul that can be
              expressed as a noun, a verb, and an emotion."
            </p>
          </div>
          <div className={styles.card}>
            <h2 className={styles.card_title}>Loyalty:</h2>
            <p className={styles.card_definition}>unwavering allegiance</p>
            <p className={styles.card_sentence}>
              "Steadfast dedication to something or someone you truly believe
              in."
            </p>
          </div>
          <div className={styles.card}>
            <h2 className={styles.card_title}>Health:</h2>
            <p className={styles.card_definition}>both in body and mind</p>
            <p className={styles.card_sentence}>
              "Flourishing in your body, sustained by nutrition, movement, and
              mindfulness"
            </p>
          </div>
          <div className={styles.card}>
            <h2 className={styles.card_title}>Courage:</h2>
            <p className={styles.card_definition}>mental and moral bravery</p>
            <p className={styles.card_sentence}>
              "A willingness and desire to step outside of your comfort zone…to
              be bold."
            </p>
          </div>
          <div className={styles.card}>
            <h2 className={styles.card_title}>Authenticity:</h2>
            <p className={styles.card_definition}>
              being true and genuine to yourself
            </p>
            <p className={styles.card_sentence}>
              "Sharing your truth, speaking, and living from your heart. Being
              genuine."
            </p>
          </div>
        </div>
        <p className={styles.grey_title}>More than just a fitness coach.</p>
        <p>
        While my em•powerment program is based in fitness, I also provide a holistic 
        journey to total wellness by using…
        </p>
        <div className={styles.practices}>
          <p>QIGONG</p>
          <p>MARTIAL ARTS</p>
          <p>YOGA</p>
          <p>PILATES</p>
        </div>
        <p>
          Drawing upon 20 years of education, coaching and training; I have designed a place 
          for you to have the resources to achieve strength and harmony between the mind, body, 
          and spirit.
        </p>
      </div>
    </section>

    <Quote
      quote={"Be firm in your outcome and flexible on how you get there."}
      personName={"- Shawna"}
    />

    <section className={styles.joinCommunityRow}>
      <JoinCommunity />
    </section>

    <Evaluation />

  </Layout>
)

export default AboutPage

{
  /*
export const query = graphql`
  query {
    allWordpressWpMedia {
      edges {
        node {
          localFile {
            childImageSharp {
              fluid {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      }
    }
  }
`
 */
}
